import Store from '@store';
import BulletListOptionMenu from 'src/views/bullet-list-option-menu';
import { text as config } from '@config';
const { debounce } = require('src/utils/toolbelt');
const template = require('./edit-bullet-points.hbs');

module.exports = Backbone.View.extend({
  maxThumbnailVisible: 6,
  bulletLevel: 0,
  bulletStyle: 0,
  bulletWidth: 0,
  bulletFill: '#000000',

  events: {
    'click div.bullet-points-add-color': 'calculateColorPickerPosition',
    'change div.tab-spacing input[name="bullet-width"]': 'setBulletWidth',
    'click div.tab-spacing span.up-arrow': 'increaseBulletWidth',
    'click div.tab-spacing span.down-arrow': 'decreaseBulletWidth',
    'input div.tab-slider input[name="bullet-width"]': 'handleSlider',
    'click div.bullet-mark': 'setOrderMark',
    'click div.bullet-style': 'setBulletPoints',
    'click div.header icon#addBulletOption': 'openBulletListOptionMenu',
    'click div.header icon#editBulletOptions': 'toggleEditMode',
    'click div.header div.finish-button': 'toggleEditMode',
    'click div.footer-container div.edit-button': 'editBulletList'
  },

  handleSlider: function (event) {
    this.slideBulletWidth(event);
    this.triggerStopHandler(event);
  },

  renderTextValues: function (textarea) {
    textarea = textarea || new INKIVE.Text.Textarea().setDOM(this.element, false, true);
    if (INKIVE.EditorFacade.canvas.getMode() === 'textedit') {
      const range = INKIVE.EditorFacade.canvas.runExtensions('selectionRange', {});
      const { startLineToStyle, lastLineToStyle } = textarea.text.setLineStyling(range.start, range.end, 'bullets', this.bulletLevel, this.bulletStyle);
      for (let lineIndex = startLineToStyle; lineIndex <= lastLineToStyle; lineIndex++) {
        textarea.text.strings[lineIndex].bulletFill = this.bulletFill;
        textarea.text.strings[lineIndex].bulletWidth = this.bulletWidth;
      }

      INKIVE.EditorFacade.canvas.runExtensions('renderTextArea', { textArea: textarea });
      INKIVE.DesignFacade.trigger('text.update', this.bulletLevel);
    } else {
      INKIVE.DesignFacade.set({
        bullet_points: this.bulletLevel,
        bullet_style: this.bulletStyle,
        bullet_fill: this.bulletFill,
        bullet_width: this.bulletWidth
      });
    }
  },

  renderBulletFill: function (textarea) {
    textarea = textarea || new INKIVE.Text.Textarea().setDOM(this.element, false, true);
    if (INKIVE.EditorFacade.canvas.getMode() === 'textedit') {
      const range = INKIVE.EditorFacade.canvas.runExtensions('selectionRange', {});
      const { startLineToStyle, lastLineToStyle } = INKIVE.Helpers.getStylingPart(range.start, range.end, this.element);
      for (let lineIndex = startLineToStyle; lineIndex <= lastLineToStyle; lineIndex++) {
        textarea.text.strings[lineIndex].bulletFill = this.bulletFill;
      }
    } else {
      textarea.text.strings.forEach(string => {
        string.bulletFill = this.bulletFill;
      });
    }

    INKIVE.EditorFacade.canvas.runExtensions('renderTextArea', { textArea: textarea });
    INKIVE.DesignFacade.trigger('text.update', this.bulletLevel);
  },

  renderBulletWidth: function (textarea, skipHistory) {
    textarea = textarea || new INKIVE.Text.Textarea().setDOM(this.element, false, true);
    if (INKIVE.EditorFacade.canvas.getMode() === 'textedit') {
      const range = INKIVE.EditorFacade.canvas.runExtensions('selectionRange', {});
      const { startLineToStyle, lastLineToStyle } = INKIVE.Helpers.getStylingPart(range.start, range.end, this.element);
      for (let lineIndex = startLineToStyle; lineIndex <= lastLineToStyle; lineIndex++) {
        textarea.text.strings[lineIndex].bulletWidth = this.bulletWidth;
      }
    } else {
      textarea.text.strings.forEach(string => {
        string.bulletWidth = this.bulletWidth;
      });
    }

    INKIVE.EditorFacade.canvas.runExtensions('renderTextArea', { textArea: textarea });
    skipHistory || INKIVE.DesignFacade.trigger('text.update', this.bulletLevel);
  },

  setBulletPoints (event) {
    if (!event || !event.currentTarget) return;

    const selectedStyle = event.currentTarget;

    this.bulletStyle = Number(selectedStyle.dataset.bulletStyle);

    this.el.querySelectorAll('div.bullet-style').forEach(element => element.classList.remove('select-active'));
    selectedStyle.classList.add('select-active');
    this.el.querySelector('div.edit-button')?.classList?.remove('disabled');

    if (this.isEditing) return;

    const textArea = new INKIVE.Text.Textarea().setDOM(this.element, false);

    this.bulletLevel = this.bulletStyle ? 1 : 0;

    this.renderTextValues(textArea);
  },

  setInput: function () {
    this.renderBulletWidth();
  },

  triggerStopHandler: function () {
    INKIVE.DesignFacade.trigger('text.update', this.bulletLevel);
  },

  slideBulletWidth: function (event) {
    const sliderInput = this.el.querySelector('div.tab-slider input[name="bullet-width"]');
    const input = this.el.querySelector('div.tab-spacing input[name="bullet-width"]');
    const value = Number(sliderInput.value);

    this.setSliderBarStyle(value);
    this.bulletWidth = value;
    this.bulletLevel = 1;
    input.value = this.bulletWidth;

    if (!this.bulletStyle) return;
    this.renderBulletWidth(null, true);
  },

  setBulletWidth: function (event) {
    const input = event && event.currentTarget;
    const sliderInput = this.el.querySelector('div.tab-slider input[name="bullet-width"]');

    if (!input) return;

    input.value = input.max
      ? Math.min(parseInt(input.max), parseInt(input.value) || 0)
      : parseInt(input.value);
    input.value = input.min
      ? Math.max(parseInt(input.min), parseInt(input.value) || 0)
      : parseInt(input.value);

    this.bulletWidth = Number(input.value);
    this.bulletLevel = 1;
    sliderInput.value = this.bulletWidth;

    if (!this.bulletStyle) return;
    this.setInput();
  },

  increaseBulletWidth: function (event) {
    const button = event && event.currentTarget;
    if (!button) return;

    const input = this.el.querySelector('div.tab-spacing input[name="bullet-width"]');
    const sliderInput = this.el.querySelector('div.tab-slider input[name="bullet-width"]');

    input.stepUp();
    this.bulletWidth = Number(input.value);
    this.bulletLevel = 1;
    sliderInput.value = this.bulletWidth;

    if (!this.bulletStyle) return;
    this.renderBulletWidth();
  },

  decreaseBulletWidth: function (event) {
    const button = event && event.currentTarget;
    const sliderInput = this.el.querySelector('div.tab-slider input[name="bullet-width"]');

    if (!button) return;

    const input = this.el.querySelector('div.tab-spacing input[name="bullet-width"]');
    input.stepDown();
    this.bulletWidth = Number(input.value);
    this.bulletLevel = 1;
    sliderInput.value = this.bulletWidth;

    if (!this.bulletStyle) return;
    this.renderBulletWidth();
  },

  setSliderBarStyle: function (value) {
    const sliderInput = this.el.querySelector('div.tab-slider input[name="bullet-width"]');
    const highlightColor = INKIVE.C.WHITE_LABEL_CONFIGURATION.colors.highlight;
    const max = Number(sliderInput.max);
    const min = Number(sliderInput.min);
    const percentage = (value - min) / (max - min) * 100;
    sliderInput.style.background = `linear-gradient(to right, ${highlightColor} 0%, ${highlightColor} ${percentage}%, #d1d3d6 ${percentage}%, #d1d3d6 100%)`;
  },

  setBulletFill: function (value) {
    const colorButton = this.el.querySelector('.bullet-points-add-color');
    colorButton.style.backgroundColor = value;
    colorButton.setAttribute('data-value', value);

    this.bulletFill = value;
    this.bulletLevel = 1;

    if (!this.bulletStyle) return;
    this.renderBulletFill();
  },

  initColorPicker: function () {
    const colorButton = this.el.querySelector('.bullet-points-add-color');
    colorButton.style.backgroundColor = this.bulletFill;
    colorButton.setAttribute('data-value', this.bulletFill);

    this.$el.find('.addmore').colorpicker({
      defaultColor: '#000000',
      onSubmit: this.setBulletFill,
      skipClearSelection: true
    });
  },

  initBulletStyle: function () {
    const activeStyle = Number(this.bulletStyle) || 0;
    this.el.querySelectorAll('.ui-dropdown-items div[data-bullet-style]').forEach(element => element.classList.remove('select-active'));
    this.el.querySelector(`.ui-dropdown-items div[data-bullet-style="${activeStyle}"]`)?.classList?.add('select-active');

    if (!this.isEditing) return;

    const styleList = Store.getState().text.bulletList.styles;
    const defaultStyles = Object.keys(styleList).filter(key => styleList[key].mode === config.mode.default || styleList[key].isImported);
    this.el.querySelector('div.edit-button')?.classList?.toggle('disabled', !this.bulletStyle);

    defaultStyles.forEach(style => {
      this.el.querySelector(`.ui-dropdown-items div[data-bullet-style="${style}"]`)?.classList?.add('disabled');
    });
  },

  calculateColorPickerPosition: function () {
    const addMoreButton = this.el.querySelector('.bullet-points-add-color');
    const rect = addMoreButton.getBoundingClientRect();
    const colorPicker = document.querySelector('.addmore-color-picker');
    const marginLeft = -210;
    const marginTop = 10;
    colorPicker.style.top = `${rect.top + marginTop}px`;
    colorPicker.style.left = `${rect.left + marginLeft}px`;
  },

  updateBulletAttributes (data) {
    this.bulletStyle = Number(data.bulletStyle) || 0;
    this.bulletFill = data.bulletFill;
    this.bulletWidth = Number(data.bulletWidth) || 0;
  },

  updateTemplate (buttonsFlagData) {
    if (buttonsFlagData.bulletProcessed) return;

    buttonsFlagData.bulletProcessed = true;

    this.updateBulletAttributes(buttonsFlagData);

    document.querySelectorAll('.ui-dropdown-items div[data-bullet-style]').forEach(element => element.classList.remove('select-active'));
    document.querySelector(`.ui-dropdown-items div[data-bullet-style="${this.bulletStyle}"]`)?.classList?.add('select-active');

    const colorButton = document.querySelector('div.tab-color .bullet-points-add-color');
    colorButton.style.backgroundColor = this.bulletFill;
    colorButton.setAttribute('data-value', this.bulletFill);

    const inputBulletWidth = document.querySelector('div.tab-slider input[name="bullet-width"]');
    const sliderBulletWidth = document.querySelector('div.tab-spacing input[name="bullet-width"]');

    inputBulletWidth.value = this.bulletWidth;
    sliderBulletWidth.value = this.bulletWidth;
  },

  mapMenuOptions: function (styles) {
    const options = [];

    for (const [key, style] of Object.entries(styles)) {
      options.push({
        bulletStyle: key,
        labels: style.symbols.map(symbol => symbol).splice(0, config.textListOptionMenu.menuDisplayMaxLevel)
      });
    }

    return options;
  },

  openBulletListOptionMenu: function () {
    BulletListOptionMenu.mountApp(this);
  },

  toggleEditMode: function () {
    this.isEditing = !this.isEditing;
    this.bulletStyle = 0;
    this.render();
  },

  editBulletList: function () {
    if (!this.bulletStyle) return;

    const styleList = Store.getState().text.bulletList.styles;
    const selectedValues = styleList[Number(this.bulletStyle)]?.charCodes;
    BulletListOptionMenu.mountApp(this, selectedValues);
  },

  initialize: function (options) {
    _.bindAll(this, 'setBulletFill', 'updateTemplate');

    this.setInput = debounce(this.setInput.bind(this), 200);
    this.triggerStopHandler = debounce(this.triggerStopHandler.bind(this), 200);

    this.element = options.selectedElement;
    this.isEditing = false;

    const textArea = new INKIVE.Text.Textarea().setDOM(this.element, false);
    const textBulletStyle = textArea.text.strings.filter(string => string.isEol).map(string => string.bulletStyle);
    const textBulletFill = textArea.text.strings.filter(string => string.isEol).map(string => string.bulletFill);
    const textBulletWidth = textArea.text.strings.filter(string => string.isEol).map(string => string.bulletWidth);

    this.bulletLevel = document.querySelector('.btn[data-action="on_set-bullets"]')?.classList?.contains('applied') ? 1 : 0;
    this.bulletFill = new Set(textBulletFill).size === 1 && textBulletFill[0] ? textBulletFill[0] : '#000000';
    this.bulletWidth = new Set(textBulletWidth).size === 1 && textBulletWidth[0] ? textBulletWidth[0] : 0;
    this.bulletStyle = new Set(textBulletStyle).size === 1 && textBulletStyle[0] ? textBulletStyle[0] : 0;

    this.render();
    this.setSliderBarStyle(this.bulletWidth);
    INKIVE.EditorFacade.off('bullet.selection_changed').on('bullet.selection_changed', this.updateTemplate);
  },

  render: function () {
    const state = Store.getState();
    const styles = this.mapMenuOptions(state.text.bulletList.styles);
    const isScrollable = styles.length > this.maxThumbnailVisible;

    this.$el.html(template({
      bullet: !!this.bulletLevel,
      bulletWidth: this.bulletWidth,
      menuOptions: styles,
      isEditing: this.isEditing,
      isScrollable,
      isAdvanceListEnabled: !!INKIVE.C.FEATURE_FLAG.extended_editing?.includes('advanced_list_modals')
    }));

    this.initBulletStyle();

    if (this.isEditing) return;

    this.initColorPicker();
  }
});
